﻿let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // IOI 2026-07-30: one broken subscriber must not break the publisher (was blocking cart drawer open)
      try {
        callback(data);
      } catch (e) {
        console.error('pubsub subscriber error for ' + eventName + ':', e);
      }
    });
  }
}
